(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeDetailController', EmployeeDetailController);

    EmployeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Employee', 'User', 'ProductCategory', 'PurchaseNumberingRow'];

    function EmployeeDetailController($scope, $rootScope, $stateParams, entity, Employee, User, ProductCategory, PurchaseNumberingRow) {
        var vm = this;
        vm.employee = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:employeeUpdate', function(event, result) {
            vm.employee = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
